import React, { Component } from 'react';
import './Footer.css';

class Footer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      year: new Date().getFullYear()
    }
  }

  render() {
    const { year } = this.state;
    return (
      <div className='row footer-container'>
        <div className='row container-lg'>
          <div className='col col-12 col-sm-4'>
            <div className="title">
              Contacto
            </div>
            <div className="text">
              <p>9250 W Bay Harbor Dr, Apt 7 D</p>
              <p>Bay Harbor Islands</p>
              <p>FL, 33154</p>
              <p>Miami (305)343-8780</p>
              <p>Bs As. 5453-9491</p> 
              <p>joseusa@me.com</p>
            </div>
          </div>
          <div className='col col-12 col-sm-4'>
            <div className="title">
              Redes Sociales
            </div>
            <div className="social">
              <a rel="noopener noreferrer" href="https://www.facebook.com/Usaproductos1/" target="_blank" className="facebook">
                <i className="fab fa-facebook"></i>
                Facebook
              </a>
              <a rel="noopener noreferrer" href="https://www.instagram.com/usaproductos" target="_blank" className="instagram">
                <i className="fab fa-instagram"></i>
                Instagram
              </a>
            </div>
          </div>
          <div className='col col-12 col-sm-4'>
            <div className="text">
              <p><span className="brand">Usaproductos</span> © {year}</p>
              <p>Desarrollo <a rel="noopener noreferrer" href="https://www.guidodipaolo.com/" target="_link">Guido Di Paolo</a></p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js